import { render, staticRenderFns } from "./solid-text-button.vue?vue&type=template&id=53791614"
import script from "./solid-text-button.vue?vue&type=script&lang=js"
export * from "./solid-text-button.vue?vue&type=script&lang=js"
import style0 from "./solid-text-button.vue?vue&type=style&index=0&id=53791614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports